"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIs = require("react-is");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _useTimeout = _interopRequireDefault(require("@mui/utils/useTimeout"));
var _clamp = _interopRequireDefault(require("@mui/utils/clamp"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _Zoom = _interopRequireDefault(require("../Zoom"));
var _Fab = _interopRequireDefault(require("../Fab"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _isMuiElement = _interopRequireDefault(require("../utils/isMuiElement"));
var _useForkRef = _interopRequireDefault(require("../utils/useForkRef"));
var _useControlled = _interopRequireDefault(require("../utils/useControlled"));
var _speedDialClasses = _interopRequireWildcard(require("./speedDialClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, open = ownerState.open, direction = ownerState.direction;
    var slots = {
        root: [
            'root',
            "direction".concat((0, _capitalize.default)(direction))
        ],
        fab: [
            'fab'
        ],
        actions: [
            'actions',
            !open && 'actionsClosed'
        ]
    };
    return (0, _composeClasses.default)(slots, _speedDialClasses.getSpeedDialUtilityClass, classes);
};
function getOrientation(direction) {
    if (direction === 'up' || direction === 'down') {
        return 'vertical';
    }
    if (direction === 'right' || direction === 'left') {
        return 'horizontal';
    }
    return undefined;
}
var dialRadius = 32;
var spacingActions = 16;
var SpeedDialRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["direction".concat((0, _capitalize.default)(ownerState.direction))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        zIndex: (theme.vars || theme).zIndex.speedDial,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    direction: 'up'
                },
                style: _define_property({
                    flexDirection: 'column-reverse'
                }, "& .".concat(_speedDialClasses.default.actions), {
                    flexDirection: 'column-reverse',
                    marginBottom: -dialRadius,
                    paddingBottom: spacingActions + dialRadius
                })
            },
            {
                props: {
                    direction: 'down'
                },
                style: _define_property({
                    flexDirection: 'column'
                }, "& .".concat(_speedDialClasses.default.actions), {
                    flexDirection: 'column',
                    marginTop: -dialRadius,
                    paddingTop: spacingActions + dialRadius
                })
            },
            {
                props: {
                    direction: 'left'
                },
                style: _define_property({
                    flexDirection: 'row-reverse'
                }, "& .".concat(_speedDialClasses.default.actions), {
                    flexDirection: 'row-reverse',
                    marginRight: -dialRadius,
                    paddingRight: spacingActions + dialRadius
                })
            },
            {
                props: {
                    direction: 'right'
                },
                style: _define_property({
                    flexDirection: 'row'
                }, "& .".concat(_speedDialClasses.default.actions), {
                    flexDirection: 'row',
                    marginLeft: -dialRadius,
                    paddingLeft: spacingActions + dialRadius
                })
            }
        ]
    };
}));
var SpeedDialFab = (0, _zeroStyled.styled)(_Fab.default, {
    name: 'MuiSpeedDial',
    slot: 'Fab',
    overridesResolver: function(props, styles) {
        return styles.fab;
    }
})({
    pointerEvents: 'auto'
});
var SpeedDialActions = (0, _zeroStyled.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Actions',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})({
    display: 'flex',
    pointerEvents: 'auto',
    variants: [
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return !ownerState.open;
            },
            style: {
                transition: 'top 0s linear 0.2s',
                pointerEvents: 'none'
            }
        }
    ]
});
var SpeedDial = /*#__PURE__*/ React.forwardRef(function SpeedDial(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDial'
    });
    var theme = (0, _zeroStyled.useTheme)();
    var defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    var ariaLabel = props.ariaLabel, tmp = props.FabProps, _ref = tmp === void 0 ? {} : tmp, origDialButtonRef = _ref.ref, childrenProp = props.children, className = props.className, _props_direction = props.direction, direction = _props_direction === void 0 ? 'up' : _props_direction, _props_hidden = props.hidden, hidden = _props_hidden === void 0 ? false : _props_hidden, icon = props.icon, onBlur = props.onBlur, onClose = props.onClose, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onOpen = props.onOpen, openProp = props.open, openIcon = props.openIcon, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, TransitionComponentProp = props.TransitionComponent, TransitionPropsProp = props.TransitionProps, _props_transitionDuration = props.transitionDuration, transitionDuration = _props_transitionDuration === void 0 ? defaultTransitionDuration : _props_transitionDuration, FabProps = _object_without_properties(props.FabProps, [
        "ref"
    ]), other = _object_without_properties(props, [
        "ariaLabel",
        "FabProps",
        "children",
        "className",
        "direction",
        "hidden",
        "icon",
        "onBlur",
        "onClose",
        "onFocus",
        "onKeyDown",
        "onMouseEnter",
        "onMouseLeave",
        "onOpen",
        "open",
        "openIcon",
        "slots",
        "slotProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration"
    ]);
    var _ref1 = _sliced_to_array((0, _useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'SpeedDial',
        state: 'open'
    }), 2), open = _ref1[0], setOpenState = _ref1[1];
    var ownerState = _object_spread_props(_object_spread({}, props), {
        open: open,
        direction: direction
    });
    var classes = useUtilityClasses(ownerState);
    var eventTimer = (0, _useTimeout.default)();
    /**
   * an index in actions.current
   */ var focusedAction = React.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ var nextItemArrowKey = React.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ var actions = React.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    var handleOwnFabRef = React.useCallback(function(fabFef) {
        actions.current[0] = fabFef;
    }, []);
    var handleFabRef = (0, _useForkRef.default)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */ var createHandleSpeedDialActionButtonRef = function(dialActionIndex, origButtonRef) {
        return function(buttonRef) {
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) {
                origButtonRef(buttonRef);
            }
        };
    };
    var handleKeyDown = function(event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
        var key = event.key.replace('Arrow', '').toLowerCase();
        var tmp = nextItemArrowKey.current, nextItemArrowKeyCurrent = tmp === void 0 ? key : tmp;
        if (event.key === 'Escape') {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) {
                onClose(event, 'escapeKeyDown');
            }
            return;
        }
        if (getOrientation(key) === getOrientation(nextItemArrowKeyCurrent) && getOrientation(key) !== undefined) {
            event.preventDefault();
            var actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;
            // stay within array indices
            var nextAction = (0, _clamp.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    React.useEffect(function() {
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    var handleClose = function(event) {
        if (event.type === 'mouseleave' && onMouseLeave) {
            onMouseLeave(event);
        }
        if (event.type === 'blur' && onBlur) {
            onBlur(event);
        }
        eventTimer.clear();
        if (event.type === 'blur') {
            eventTimer.start(0, function() {
                setOpenState(false);
                if (onClose) {
                    onClose(event, 'blur');
                }
            });
        } else {
            setOpenState(false);
            if (onClose) {
                onClose(event, 'mouseLeave');
            }
        }
    };
    var handleClick = function(event) {
        if (FabProps.onClick) {
            FabProps.onClick(event);
        }
        eventTimer.clear();
        if (open) {
            setOpenState(false);
            if (onClose) {
                onClose(event, 'toggle');
            }
        } else {
            setOpenState(true);
            if (onOpen) {
                onOpen(event, 'toggle');
            }
        }
    };
    var handleOpen = function(event) {
        if (event.type === 'mouseenter' && onMouseEnter) {
            onMouseEnter(event);
        }
        if (event.type === 'focus' && onFocus) {
            onFocus(event);
        }
        // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        eventTimer.clear();
        if (!open) {
            // Wait for a future focus or click event
            eventTimer.start(0, function() {
                setOpenState(true);
                if (onOpen) {
                    var eventMap = {
                        focus: 'focus',
                        mouseenter: 'mouseEnter'
                    };
                    onOpen(event, eventMap[event.type]);
                }
            });
        }
    };
    // Filter the label for valid id characters.
    var id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    var allItems = React.Children.toArray(childrenProp).filter(function(child) {
        if (process.env.NODE_ENV !== 'production') {
            if ((0, _reactIs.isFragment)(child)) {
                console.error([
                    "MUI: The SpeedDial component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.'
                ].join('\n'));
            }
        }
        return /*#__PURE__*/ React.isValidElement(child);
    });
    var children = allItems.map(function(child, index) {
        var _child_props = child.props, tmp = _child_props.FabProps, _ref = tmp === void 0 ? {} : tmp, origButtonRef = _ref.ref, tooltipPlacementProp = _child_props.tooltipPlacement, ChildFabProps = _object_without_properties(_child_props.FabProps, [
            "ref"
        ]);
        var tooltipPlacement = tooltipPlacementProp || (getOrientation(direction) === 'vertical' ? 'left' : 'top');
        return /*#__PURE__*/ React.cloneElement(child, {
            FabProps: _object_spread_props(_object_spread({}, ChildFabProps), {
                ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
            }),
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: "".concat(id, "-action-").concat(index)
        });
    });
    var backwardCompatibleSlots = _object_spread({
        transition: TransitionComponentProp
    }, slots);
    var backwardCompatibleSlotProps = _object_spread({
        transition: TransitionPropsProp
    }, slotProps);
    var externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    var _ref2 = _sliced_to_array((0, _useSlot.default)('root', {
        elementType: SpeedDialRoot,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        additionalProps: {
            role: 'presentation'
        },
        getSlotProps: function(handlers) {
            return _object_spread_props(_object_spread({}, handlers), {
                onKeyDown: function(event) {
                    var _handlers_onKeyDown;
                    (_handlers_onKeyDown = handlers.onKeyDown) === null || _handlers_onKeyDown === void 0 ? void 0 : _handlers_onKeyDown.call(handlers, event);
                    handleKeyDown(event);
                },
                onBlur: function(event) {
                    var _handlers_onBlur;
                    (_handlers_onBlur = handlers.onBlur) === null || _handlers_onBlur === void 0 ? void 0 : _handlers_onBlur.call(handlers, event);
                    handleClose(event);
                },
                onFocus: function(event) {
                    var _handlers_onFocus;
                    (_handlers_onFocus = handlers.onFocus) === null || _handlers_onFocus === void 0 ? void 0 : _handlers_onFocus.call(handlers, event);
                    handleOpen(event);
                },
                onMouseEnter: function(event) {
                    var _handlers_onMouseEnter;
                    (_handlers_onMouseEnter = handlers.onMouseEnter) === null || _handlers_onMouseEnter === void 0 ? void 0 : _handlers_onMouseEnter.call(handlers, event);
                    handleOpen(event);
                },
                onMouseLeave: function(event) {
                    var _handlers_onMouseLeave;
                    (_handlers_onMouseLeave = handlers.onMouseLeave) === null || _handlers_onMouseLeave === void 0 ? void 0 : _handlers_onMouseLeave.call(handlers, event);
                    handleClose(event);
                }
            });
        }
    }), 2), RootSlot = _ref2[0], rootSlotProps = _ref2[1];
    var _ref3 = _sliced_to_array((0, _useSlot.default)('transition', {
        elementType: _Zoom.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), TransitionSlot = _ref3[0], transitionProps = _ref3[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, _object_spread_props(_object_spread({
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true
            }, transitionProps), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpeedDialFab, _object_spread_props(_object_spread({
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": "".concat(id, "-actions")
                }, FabProps), {
                    onClick: handleClick,
                    className: (0, _clsx.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ React.isValidElement(icon) && (0, _isMuiElement.default)(icon, [
                        'SpeedDialIcon'
                    ]) ? /*#__PURE__*/ React.cloneElement(icon, {
                        open: open
                    }) : icon
                }))
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpeedDialActions, {
                id: "".concat(id, "-actions"),
                role: "menu",
                "aria-orientation": getOrientation(direction),
                className: (0, _clsx.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});
process.env.NODE_ENV !== "production" ? SpeedDial.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */ ariaLabel: _propTypes.default.string.isRequired,
    /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The direction the actions open relative to the floating action button.
   * @default 'up'
   */ direction: _propTypes.default.oneOf([
        'down',
        'left',
        'right',
        'up'
    ]),
    /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) element.
   * @default {}
   */ FabProps: _propTypes.default.object,
    /**
   * If `true`, the SpeedDial is hidden.
   * @default false
   */ hidden: _propTypes.default.bool,
    /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */ icon: _propTypes.default.node,
    /**
   * @ignore
   */ onBlur: _propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */ onClose: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * @ignore
   */ onKeyDown: _propTypes.default.func,
    /**
   * @ignore
   */ onMouseEnter: _propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: _propTypes.default.func,
    /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"focus"`, `"mouseEnter"`.
   */ onOpen: _propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: _propTypes.default.bool,
    /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */ openIcon: _propTypes.default.node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        transition: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        root: _propTypes.default.elementType,
        transition: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Zoom
   * * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ TransitionComponent: _propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.shape({
            appear: _propTypes.default.number,
            enter: _propTypes.default.number,
            exit: _propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ TransitionProps: _propTypes.default.object
} : void 0;
var _default = exports.default = SpeedDial;
